import { render, staticRenderFns } from "./UsageComparisonsTable.vue?vue&type=template&id=07eba3c4&scoped=true&"
import script from "./UsageComparisonsTable.vue?vue&type=script&lang=js&"
export * from "./UsageComparisonsTable.vue?vue&type=script&lang=js&"
import style0 from "./UsageComparisonsTable.vue?vue&type=style&index=0&id=07eba3c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eba3c4",
  null
  
)

/* custom blocks */
import block0 from "./UsageComparisonsTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports